export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const PREVENT_URL = "不適切なURLです";
export const DEFAULT_TIMER = 1000;
export const INVALID_MUST_AFTER_DATE = "「{{end}}」は「{{start}}」より後にする必要があります";
export const MAX_INTEGER = 2147483646;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
